import { configureStore, Action, EnhancedStore, ThunkAction } from '@reduxjs/toolkit';

import rootReducer, { RootState } from './rootReducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createStore(): EnhancedStore<any, any> {
    return configureStore({
        reducer: rootReducer,
    });
}

const store = createStore();

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./rootReducer', () => {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const newRootReducer = require('./rootReducer').default;
        store.replaceReducer(newRootReducer);
    });
}

export type AppDispatch = typeof store.dispatch;
// TODO Think about moving it out to shared packages as AppThunk<T> type
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export default store;

export type AppStore = typeof store;

export type AppState = RootState;
